import {AppState} from 'app/reducers';

import {TTNState} from '../reducers';

export const getLoadSelector = (state: AppState): TTNState => {
    return state.loadState;
};
